export const STAGE_CONFIG = {
  1: {
    title: 'Instruction received',
    description: 'We have successfully received the instruction.'
  },
  2: {
    title: 'Requirements validation',
    description: 'The instruction details are under review for accuracy and compliance.'
  },
  3: {
    title: 'Processing in progress',
    description: 'We are coordinating the instruction.'
  },
  4: {
    title: 'Completed',
    description: 'The request has been completed. Confirmation will be sent email.'
  }
} as const;
